import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const ReportsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isDashboard =
    location.pathname === '/reports' ||
    location.pathname === '/reports/dashboard';

  return (
    <div className='h-svh'>
      <div className='flex h-full flex-col'>
        {/* Header */}
        <div className='flex-shrink-0 border-b bg-background px-6 py-4'>
          <div className='space-y-1'>
            <div className='flex items-center justify-between'>
              <div>
                <h1 className='text-xl font-bold tracking-tight'>
                  {isDashboard ? 'Reports · Dashboard' : 'Reports · Responses'}
                </h1>
                <p className='text-sm text-muted-foreground'>
                  {isDashboard
                    ? 'View your sales funnel and revenue metrics'
                    : 'Analyze response times and team performance'}
                </p>
              </div>
              <div className='flex items-center gap-2'>
                <Tabs
                  value={isDashboard ? 'dashboard' : 'responses'}
                  onValueChange={(v) =>
                    navigate(
                      v === 'dashboard'
                        ? '/reports/dashboard'
                        : '/reports/responses'
                    )
                  }
                  className='w-auto'
                >
                  <TabsList className='grid grid-cols-2'>
                    <TabsTrigger
                      value='dashboard'
                      className='text-xs sm:text-sm'
                    >
                      Dashboard
                    </TabsTrigger>
                    <TabsTrigger
                      value='responses'
                      className='text-xs sm:text-sm'
                    >
                      Responses
                    </TabsTrigger>
                  </TabsList>
                </Tabs>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className='min-h-0 flex-1'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReportsLayout;
